import { render, staticRenderFns } from "./setGame5.vue?vue&type=template&id=35489d02&"
import script from "./setGame5.vue?vue&type=script&lang=js&"
export * from "./setGame5.vue?vue&type=script&lang=js&"
import style0 from "./setGame5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports